import script from "./SovaClub.vue?vue&type=script&setup=true&lang=js"
export * from "./SovaClub.vue?vue&type=script&setup=true&lang=js"

import "./SovaClub.vue?vue&type=style&index=0&id=2b6c4918&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b6c4918"]])

export default __exports__